'use client';

// @ts-ignore
import { TextVideo as UITextVideo } from '@stereoagency/ui';
// @ts-ignore
// import { textVideo } from '@stereoagency/sanity-schema';
import { SimpleBlockContent } from '../sanity/client';
import { actionAsProps, sanityImageAsProps } from '@/utils';

// type Props = typeof textVideo.schema.textVideo & {
//   image?: any;
//   caption?: any;
//   video?: any;
// };

export default function TextVideo({
  actionLabel,
  title,
  description,
  image,
  caption,
  video,
  action
}: any) {
  if (!title) {
    return null;
  }

  return (
    <UITextVideo
      title={title}
      description={
        description ? <SimpleBlockContent value={description} /> : null
      }
      image={sanityImageAsProps(image)}
      actionLabel={actionLabel}
      video={video}
      action={action ? actionAsProps(action) : undefined}
      label={<SimpleBlockContent value={caption} />}
    />
  );
}
